import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  padding:10px;
  flex-direction:column;
`;

const FormBox = styled.form`
  width: 100%;
  background-color: #ffffff;
  border-radius: 10px;
`;

const Input = styled.input`
  width: calc(100% - 20px);
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
`;

const Button = styled.button`
  width: 100%;
  padding: 10px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #45a049;
  }
`;

const Title = styled.h2`
  text-align: left;
  color: #333;
  margin-bottom: 20px;
`;

function BusinessInfo() {
  const [companyName, setCompanyName] = useState("");
  const [businessNumber, setBusinessNumber] = useState("");
  const [representativeName, setRepresentativeName] = useState("");
  const [industryType, setIndustryType] = useState("");
  const [businessCategory, setBusinessCategory] = useState("");
  const [bank, setBank] = useState("");
  const [address, setAddress] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBusinessInfo = async () => {
      try {
        const response = await fetch('/request/getBusinessInfo', {
          method: 'GET',
          credentials: 'include',
        });
        if (response.ok) {
          const data = await response.json();
          setCompanyName(data.company_name);
          setBusinessNumber(data.business_number);
          setRepresentativeName(data.representative_name);
          setIndustryType(data.industry_type);
          setBusinessCategory(data.business_category);
          setAddress(data.address);
          setBank(data.bank)
        } else {
          throw new Error('Failed to fetch business info');
        }
      } catch (error) {
        console.error('Error fetching business info:', error);
        navigate('/login');
      }
    };

    fetchBusinessInfo();
  }, []);

  const handleUpdate = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch('/request/updateBusinessInfo', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          company_name: companyName,
          business_number: businessNumber,
          representative_name: representativeName,
          industry_type: industryType,
          business_category: businessCategory,
          bank : bank,
          address: address,
        }),
        credentials: 'include',
      });

      if (!response.ok) throw new Error('Failed to update business info');
      alert('정보가 업데이트되었습니다.');
      navigate('/mypage');
    } catch (error) {
      console.error('Error updating business info:', error);
    }
  };

  return (
    <Container>
      <section style={{display:'flex', flexDirection:'row'}}>
      <FormBox onSubmit={handleUpdate}>
        <Title>사업자 정보 수정</Title>
        <Input
          type="text"
          placeholder="회사명"
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
        />
        <Input
          type="text"
          placeholder="사업자 번호"
          value={businessNumber}
          onChange={(e) => setBusinessNumber(e.target.value)}
        />
        <Input
          type="text"
          placeholder="대표자명"
          value={representativeName}
          onChange={(e) => setRepresentativeName(e.target.value)}
        />
        <Input
          type="text"
          placeholder="업종"
          value={industryType}
          onChange={(e) => setIndustryType(e.target.value)}
        />
        <Input
          type="text"
          placeholder="업태"
          value={businessCategory}
          onChange={(e) => setBusinessCategory(e.target.value)}
        />
        <Input
          type="text"
          placeholder="주소"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
        />
      </FormBox>
      </section>
      <Button type="submit">정보 업데이트</Button>
    </Container>
  );
}

export default BusinessInfo;